import {
  ReservationsDetails,
  ReservationsDetailsSegment,
} from "@kiwicom/frontend-common/components/Itinerary/SegmentPNR/types"

import { ReservationsDetailsInput } from "../../../../../../../records/bookingInput"

export default function mapperReservationsDetails(
  reservationsDetailsInput?: ReservationsDetailsInput | null,
): ReservationsDetails | null | undefined {
  // API on deprecated account page doesn't send reservations_details in bookings response
  if (!reservationsDetailsInput) {
    return null
  }

  return Object.keys(reservationsDetailsInput).reduce(
    (acc: ReservationsDetails, segmentId: string) => ({
      ...acc,
      [segmentId]: Object.keys(reservationsDetailsInput[segmentId]).reduce(
        (accPassengers: ReservationsDetailsSegment, passengerId: string) => ({
          ...accPassengers,
          [passengerId]: {
            eticketNumber: reservationsDetailsInput[segmentId][passengerId].eticket_number,
            reservationNumber: reservationsDetailsInput[segmentId][passengerId].reservation_number,
          },
        }),
        // freeze to fix Flow error 'inexact object literal is incompatible with exact ReservationsDetailsSegment'
        Object.freeze({}),
      ),
    }),
    // freeze to fix Flow error 'inexact object literal is incompatible with exact ReservationsDetails'
    Object.freeze({}),
  )
}
